import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'antd';

import Layout from '../../layout/Layout';
import './styles.less';

const NotFound = () => {
  return (
    <Layout>
      <div className="not-found-page">
        <img height="256" src="/404.svg" aria-label="Page not found error" />
        <div>
          <div className="not-found-page-message">Lost your way ?</div>
          <Link to="/">
            {' '}
            <Button type="primary">Go back home</Button>
          </Link>
        </div>
      </div>
    </Layout>
  );
};

export default NotFound;
